import { instanceFlask } from "api/axiosConfig";

// Every request carries the source files themselves: the server keeps nothing
// between calls, and the content references in a structure are positions
// recomputed from the file's bytes, so the same files must accompany them.
const appendDocuments = (form, documents) => {
  documents.forEach((document) => form.append("files", document.file, document.filename));
  form.append("documentIds", JSON.stringify(documents.map((document) => document.documentId)));
};

const filenameFrom = (headers, fallback) => {
  const explicit = headers?.["x-document-filename"];
  if (explicit) return explicit;

  const disposition = headers?.["content-disposition"] || "";
  const match = disposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
  return match ? decodeURIComponent(match[1]) : fallback;
};

const parseWarnings = (headers) => {
  try {
    const raw = headers?.["x-build-warnings"];
    const warnings = raw ? JSON.parse(raw) : [];
    return Array.isArray(warnings) ? warnings : [];
  } catch {
    return [];
  }
};

/**
 * The message behind a failed request. Endpoints that return a file are asked
 * for a blob, so their error bodies arrive as blobs too and have to be read
 * back before the message inside them can be shown.
 */
export const readErrorMessage = async (error, fallback = "Something went wrong.") => {
  const data = error?.response?.data;

  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text());
      return parsed.error || parsed.message || fallback;
    } catch {
      return fallback;
    }
  }

  return data?.error || data?.message || error?.message || fallback;
};

export const getHealth = async () => {
  const response = await instanceFlask.get("/builder/health");
  return response.data;
};

export const analyzeDocuments = async (documents) => {
  const form = new FormData();
  appendDocuments(form, documents);

  const response = await instanceFlask.post("/builder/analyze", form);
  return response.data.documents;
};

export const generateDocument = async ({ documents, structure, cover }) => {
  const form = new FormData();
  appendDocuments(form, documents);
  form.append("structure", JSON.stringify(structure));
  form.append("cover", JSON.stringify(cover));

  const response = await instanceFlask.post("/builder/generate", form, { responseType: "blob" });

  return {
    blob: response.data,
    filename: filenameFrom(response.headers, "Custom PSMF.docx"),
    warnings: parseWarnings(response.headers)
  };
};

export const convertToPdf = async (blob, filename) => {
  const form = new FormData();
  form.append("file", blob, filename);

  const response = await instanceFlask.post("/builder/convert", form, { responseType: "blob" });

  return {
    blob: response.data,
    filename: filenameFrom(response.headers, filename.replace(/\.docx$/i, ".pdf"))
  };
};
